import * as React from 'react';
import { TabList } from 'react-tabs';

import hoistNonReactStatics from 'hoist-non-react-statics';

import { styled } from '../theme';

const TabsMenu = styled(TabList)<{ style?: React.CSSProperties }>(({ theme, style = {} }) => ({
    flexShrink: 0,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    height: 50,
    lineHeight: '50px',
    ...style,
    '> * + *': {
        marginLeft: 40,
    },
}));

export default hoistNonReactStatics(TabsMenu, TabList);
